'use struct';

export function ga_mal_banner() {
  if (typeof ga !== 'undefined') {
    ga('send', 'event', 'support_mal', '2-3.MALバナー', '/membership?utm_source=myanimelist&utm_medium=banner&utm_campaign=support_mal_20200416&utm_content=minibanner&c-ms-mode=3');
  }
}

export function ga_credit() {
  if (typeof ga !== 'undefined') {
    ga('send', 'event', 'support_mal', '3-1-1.クレカ登録', '/member-register?c-ms_payment=1&c-ms_mode=3');
  }
}

export function ga_paypal() {
  if (typeof ga !== 'undefined') {
    ga('send', 'event', 'support_mal', '3-1-2.Paypal登録', '/member-register?c-ms_payment=2&c-ms_mode=3');
  }
}
